export const validation = {
  maxTitleChar: 50,
  maxParagraphChar: 500
}